import styled from '@emotion/styled';

interface ProgressThumbProps {
  top: number;
  height: number;
  gradient?: string;
}

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 32px;
  z-index: 999;
  padding: 48px 0;
`;

export const ProgressTrack = styled.div`
  position: relative;
  width: 8px;
  flex: 1;
  background-color: #f2f2f2;
  border-radius: 4px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

export const ProgressThumb = styled.div<ProgressThumbProps>`
  position: absolute;
  top: ${({ top }) => top}%;
  left: 0;
  width: 8px;
  height: ${({ height }) => height}%;
  background: ${({ gradient }) =>
    gradient || 'linear-gradient(#5c6d66 0%, #a2b697 100%)'};
  border-radius: 4px;
  transition: all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  min-height: 20px;
  max-height: 80%;
`;
